import flow from 'lodash/fp/flow';
import get from 'lodash/fp/get';

const getDownloads = get('downloads');

export const getIsDownloading = flow(getDownloads, get('isDownloading'));
